import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';

import { ProgressBar } from './progressbar-component';

interface ProgressProp {
    progress: string;
}

export const Header = ({ progress }: ProgressProp) => {
    const { cartData } = useContext(CartContext);
    const { t } = useTranslation();

    return (
        <header className="header__wrap">
            <div aria-label="Logo" className="header__logo">
                <a href="/">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.56 76.36" className="svgTscLogoLg">
                        <path
                            d="M111.04,42.4c-.83-.67-3.15-.66-3.18-1.97l2.38-7.81-7.32,1.55-2.06-3.54c-1.46.77-4.64,5.64-5.66,5.92-.5.14-.83.13-1.14-.33-.8-1.17,2.47-12.15,2.21-14.38-1.08.52-4.04,3.04-5.14,2.35l-4.05-8.33c-.17-.04-.29-.06-.39-.06v39.89c1.61-.03,2.29-.03,2.29-.03,1.19-.11,9,1.74,10.88,2.12l-1.39-4.8,12.57-10.57Z"
                            fill="#dd302d"
                        />
                        <g>
                            <path d="M64.57,30.61c-4.25,0-7.86,3.7-7.86,8.09s3.61,8.13,7.86,8.13c2.48,0,4.7-1.26,6.19-3.16l4.13,3.61c.69-2.86,1.07-5.83,1.07-8.9,0-2.88-.33-5.67-.94-8.36l-4.3,3.76c-1.45-1.9-3.71-3.16-6.15-3.16" />
                            <path d="M27.69,23.2v2.55c2.15-1.97,5.33-3.09,9.22-3.09,5.38,0,9.58,1.45,13.01,4.2l-4.38,6.19c-2.89-2.08-6.06-3.12-8.86-3.12-2.12,0-3.16.86-3.16,2.03,0,1.58,1.08,2.08,5.51,3.03,3.65.78,6.61,1.66,8.65,3.11.35-8.45,7.92-15.44,16.88-15.44,3.3,0,6.39.94,9.02,2.55C68.24,10.87,54.43.66,38.24.66S9.55,9.93,3.71,23.2h23.98Z" />
                            <path d="M64.57,54.79c-5.86,0-11.13-3.01-14.17-7.46-1.3,4.75-5.87,7.46-12.4,7.46-5.6,0-10.89-1.76-14.82-5.24l4.88-5.83c3.16,2.48,6.6,3.79,10.26,3.79,2.39,0,3.66-.81,3.66-2.17,0-1.49-1.08-1.72-5.38-2.71-6.73-1.54-11.93-3.3-11.93-9.76,0-.64.06-1.26.17-1.85h-6.31v23.23h-8.77v-23.23H1.25c-.47,2.38-.72,4.84-.72,7.36,0,20.83,16.88,37.72,37.71,37.72,15.86,0,29.42-9.79,34.99-23.65-2.55,1.49-5.51,2.34-8.67,2.34" />
                        </g>
                    </svg>
                </a>
                <h1 className="header__logo-text">{t('Checkout')}</h1>
            </div>

            <div className="header__progressbar">
                <ProgressBar progress={progress} />
            </div>
            <div className="header__cart-button">
                <a
                    href="/pages/shoppingbag"
                    data-link-type="link"
                    data-link-title="shopping bag"
                    data-link-position="top"
                    data-component-type="express checkout"
                >
                    <svg className="svgCart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.07 46.03">
                        <path d="M25,44H8.83c-1.56,0-3.07.08-4.45-.82-3-2-2.26-6.33-2.26-9.44V20c0-3.24-.77-7.67,2.67-9.48A8.89,8.89,0,0,1,9.07,10h6.27c3.32,0,6.72-.22,10,0a5.1,5.1,0,0,1,4.68,5.18c0,1.19,0,2.39,0,3.58V37.65a6.92,6.92,0,0,1-.83,4.08A5.08,5.08,0,0,1,25,44c-1.29,0-1.29,2,0,2A7.1,7.1,0,0,0,32,40.08a23.77,23.77,0,0,0,.09-3.48V16.5a10.15,10.15,0,0,0-.64-4.43A7.15,7.15,0,0,0,24.87,8c-1.61,0-3.21,0-4.82,0-4.21,0-8.42,0-12.63,0A7.2,7.2,0,0,0,1,11.64a9.3,9.3,0,0,0-.85,4.62V29.71c0,3.27-.29,6.68,0,9.94A7.11,7.11,0,0,0,6.46,46c1.31.13,2.65,0,4,0H25A1,1,0,0,0,25,44Z" />
                        <path d="M9.74,15.8V9.22A17.12,17.12,0,0,1,9.87,6.1c.29-1.5,1.12-3.78,2.9-4A17.75,17.75,0,0,1,15.5,2C16.67,2,17.84,2,19,2c1.42,0,2.35,1.29,2.84,2.5a10.16,10.16,0,0,1,.58,3.9V15.8a1,1,0,0,0,2,0V8.73A13.79,13.79,0,0,0,24,4.49C23.35,2.63,22.06.6,20,.14A15.52,15.52,0,0,0,16.67,0c-1.19,0-2.39,0-3.58,0-4,.09-5.35,4.77-5.35,8V15.8a1,1,0,0,0,2,0Z" />
                    </svg>
                </a>
            </div>
        </header>
    );
};
